import { Component } from '@angular/core';
import { Usuario } from '../models/usuario';
import { generalService } from '../services/general.service';
import { Router } from '@angular/router';
import { DataService } from '../utils/data.service';
import { modalComponent } from './../utils/modal/modal.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'my-login',
  styles: [],
  templateUrl: './login.component.html',
  providers: [generalService]
})

export class LoginComponent {
	public usuario:Usuario;
	public logo="MRSAE"; //IN_ORANGE, IN_WHITE, IN_FULL

	constructor(private _generalService: generalService, private _router:Router, public dataService: DataService, public dialog: MatDialog){
		this.usuario = new Usuario();
	}

	ngOnInit(){
	}

	iniciarSesion(){

    var params: any = {};
    params.email = this.usuario.email;
    params.contrasenia = this.usuario.contrasenia;

    var paramsJSON: string = JSON.stringify(params);

		this._generalService.requestGet("usuario/logIn?parametros=" + paramsJSON).subscribe(
        result => {
          if(result != ""){

              var dataTemp: any = JSON.parse(result)[0];              
              sessionStorage.setItem("acslo", dataTemp.ID_ENCRIPTADO);

              var user: any = {
                USER_ID: dataTemp.USER_ID,
                USER_NAME: dataTemp.USER_NAME,
                EMAIL: dataTemp.EMAIL,
                COMPANY_NAME: dataTemp.COMPANY_NAME,
                COMPANY_ID: dataTemp.COMPANY_ID,
                ORGANIZATION_NAME: dataTemp.ORGANIZATION_NAME,
                ORGANIZATION_ID: dataTemp.ORGANIZATION_ID,
                ADMIN: dataTemp.ADMIN,
                ADDRESS: dataTemp.ADDRESS,
                FISCAL_NAME: dataTemp.FISCAL_NAME,
                RFC : dataTemp.RFC

              }
              sessionStorage.setItem("user", JSON.stringify(user));

              this._router.navigate(['/app/inicio']);
            }
            else {
              this.usuario.contrasenia = "";
              this.modal("alert", "Usuario y/o contraseña incorrecto(s)");
            }
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
	}

  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts